import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSendMessage = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M36.6353 17.9638L5.13588 4.46334C4.85041 4.341 4.54948 4.21796 4.25136 4.21796C3.64507 4.21796 3.04904 4.46398 2.61311 4.92458C1.96497 5.6741 1.81558 6.69291 2.23744 7.53734L8.74987 20.0309L2.23765 32.5252C1.81579 33.3704 1.9652 34.3885 2.6134 35.0754C3.04848 35.5357 3.64416 35.782 4.25024 35.782C4.54906 35.782 4.85006 35.7227 5.13546 35.5996L36.6353 22.0981C37.4635 21.7443 38 20.9302 38 20.0302C37.936 19.1309 37.4649 18.3153 36.6353 17.9638ZM4.24855 6.5333C4.24715 6.53401 4.24925 6.5319 4.24855 6.5333L33.1267 18.906H10.6975L4.24855 6.5333ZM4.23238 33.5658L10.6975 21.1559H33.0635L4.23238 33.5658Z",
		fill: "currentColor"
	})
});
export default SvgSendMessage;
